export class AnalysisOriginDto {
  id: string;
  code: string;
  label: string;
  forNutrientOnly: boolean;
}

/**
 * Code for standard analysis present in data base
 */
export const STD_ANALYSIS_CODE: string = "STD";
/**
 * Code for calculated analysis present in data base
 */
export const CALCULATED_ANALYSIS_CODE: string = "CALCULATED";
